import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cookie from 'js-cookie'
import { compose } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'
import cx from 'classnames'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './CountdownBanner.scss'


class CountdownBanner extends Component {

  static propTypes = {
    intl: PropTypes.object, // @injectIntl
    message: PropTypes.object.isRequired,
    timeLeft: PropTypes.number,
  }

  static defaultProps = {
    timeLeft: 20 * 60 * 1000, // 20 mins
  }

  node          = null
  timer         = null
  initialized   = false
  timeLeft      = null

  state = {
    isExpired: false,
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  initTimer = (node) => {
    const { timeLeft } = this.props

    const _timeLeft = cookie.getJSON(`countdownBanner:timeLeft:${window.location.pathname}`)

    this.timeLeft = (_timeLeft === null || _timeLeft === undefined) ? timeLeft : _timeLeft

    if (this.initialized || !node) {
      return
    }

    this.node         = node
    this.initialized  = true
    this.timer        = setInterval(this.tick, 1000)

    this.tick()
  }

  tick = () => {
    this.timeLeft -= 1000

    if (this.timeLeft <= 0) {
      clearInterval(this.timer)

      this.setState({
        isExpired: true,
      })

      return
    }

    cookie.set(`countdownBanner:timeLeft:${window.location.pathname}`, this.timeLeft)

    const { intl } = this.props

    const mins    = Math.floor((this.timeLeft / 60 / 1000) % 60)
    const secs    = Math.floor((this.timeLeft / 1000) % 60)

    const minsTitle   = intl.formatMessage(messages.mins)
    const secsTitle   = intl.formatMessage(messages.secs)

    this.node.innerHTML = `${mins} ${minsTitle} ${secs} ${secsTitle}`
  }

  render() {
    const { isExpired } = this.state
    const { message, horizontal, uppercase } = this.props

    const className = cx(s.countdown, { [s.horizontal]: horizontal })

    return (
      <Box className={className} alignCenter>
        <Text
          message={isExpired ? messages.expired : message}
          uppercase={uppercase}
          color="white"
          size="14-24"
        />
        {
          !isExpired && (
            <Text className={s.digits} uppercase={uppercase} color="brand" size="18-24">
              <span ref={this.initTimer} />
            </Text>
          )
        }
      </Box>
    )
  }
}

export default compose(
  injectIntl,
)(CountdownBanner)
